<!-- 配送方式 -->
<template>
<span>
    <el-dialog
        :title="msg('配送方式')"
        :visible.sync="visible"
        :close-on-click-modal="false"
        size="mini"
        width="400px"
    >
        <el-row>
            <el-col :gutter="10" :xs="24" :sm="24">
                <el-select v-model="expCompany" clearable :placeholder="msg('请选择配送方式')">
                    <el-option v-for="d in expCompanys" 
                        :label="d.label" :value="d.value" :key="d.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="submit()">{{msg("提交")}}</el-button>
        </span>
    </el-dialog>
</span>    
</template>

<script>
export default {
    name: "ExpCompanyDialog",
    mounted(){
        this.getCompanys();
    },
    data(){
        return {
            visible: false,
            
            expCompanys: [],
            expCompany:null,
            selectes:[],
        } 
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    methods: {
        showDialog(selectes){
            this.selectes = selectes;
            this.expCompany = null;
            this.visible = true;
        },
        getCompanys(){
            this.$axios.get(this.$kit.api.getExpCompany)
                .then((result)=> {
                    if(result.status){
                        this.expCompanys = result.data;
                    }
                });
        },
        submit(){
            if(!this.expCompany){
                this.$message(this.msg('请选择配送方式'));
                return;
            }
            let ids = this.selectes.map(e => e.stockId).join(",")
            this.$axios.post(this.$kit.api.stockDetail.updateExpCompany
                        +"?company="+this.expCompany,
                        ids
            ).then((result) => {
                if(result.status){
                    this.visible = false;
                    this.$emit("finish");
                }
                this.$message(result.msg);
            });
        }
    }
}

</script>